var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdprdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.6875,
    width: 22,
    height: 22,
    rx: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 13.9372H11.375C11.1672 13.9372 11 13.7491 11 13.5152V10.5617H9.62969C9.35156 10.5617 9.2125 10.1837 9.40937 9.96217L11.7859 7.28639C11.9031 7.15454 12.0953 7.15454 12.2125 7.28639L14.5906 9.96217C14.7875 10.1837 14.6484 10.5617 14.3703 10.5617H13V13.5152C13 13.7491 12.8328 13.9372 12.625 13.9372ZM16 13.7965V15.7656C16 15.9994 15.8328 16.1875 15.625 16.1875H8.375C8.16719 16.1875 8 15.9994 8 15.7656V13.7965C8 13.5627 8.16719 13.3746 8.375 13.3746H10.5V13.5152C10.5 14.0585 10.8922 14.4998 11.375 14.4998H12.625C13.1078 14.4998 13.5 14.0585 13.5 13.5152V13.3746H15.625C15.8328 13.3746 16 13.5627 16 13.7965ZM14.0625 15.3436C14.0625 15.1502 13.9219 14.992 13.75 14.992C13.5781 14.992 13.4375 15.1502 13.4375 15.3436C13.4375 15.537 13.5781 15.6952 13.75 15.6952C13.9219 15.6952 14.0625 15.537 14.0625 15.3436ZM15.0625 15.3436C15.0625 15.1502 14.9219 14.992 14.75 14.992C14.5781 14.992 14.4375 15.1502 14.4375 15.3436C14.4375 15.537 14.5781 15.6952 14.75 15.6952C14.9219 15.6952 15.0625 15.537 15.0625 15.3436Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.6875,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdprdc);
export default __webpack_public_path__ + "static/media/adprdc.2873ff9034512ea428679e764355f6cb.svg";
export { ForwardRef as ReactComponent };